import React from 'react';
import classNames from 'classnames';

export const Container = ({ children, className, style }) => {
  return (
    <div
      className={classNames('mx-auto w-full max-w-[1140px] px-4', {
        [className]: className,
      })}
      style={style}
    >
      {children}
    </div>
  );
};
